import { render } from "./Billing.vue?vue&type=template&id=b8017a9c&scoped=true&ts=true"
import script from "./Billing.vue?vue&type=script&lang=ts"
export * from "./Billing.vue?vue&type=script&lang=ts"

import "./Billing.vue?vue&type=style&index=0&id=b8017a9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8017a9c"]])

export default __exports__